var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ucar-main"},[_c('div',{staticClass:"ucar-wrapper"},[_vm._t("default"),_c('img',{staticClass:"ucar-logo",attrs:{"src":require("../assets/main_footer.png")}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }